import React, { useState, useEffect } from "react";
import axios from "axios";
import logo from "../assets/logo.avif";
import Boot from "../components/Boot";
import banner from "../assets/default_banner.png";
import ContactDialog from "../components/ContactDialog";
import ShareTray from "../components/ShareTray";

// Default Metadata for fallback
const DEFAULT_METADATA = {
  bio: "Appopener",
  truncatedBio: "Default truncated bio",
  channelName: "appø",
  banner: banner,
  avatar: logo,
  channelLink: "https://www.youtube.com/@creatorcosmos",
  links: [],
};

const UserProfile = (props) => {
  const videoId = props.video_id;
  const [showPopup, setShowPopup] = useState(false);
  const [showSecondPopup, setShowSecondPopup] = useState(false);
  const [showThirdPopup, setShowThirdPopup] = useState(false);

  const [data, setChannelData] = useState(DEFAULT_METADATA);
  const [loading, setloading] = useState(false);
  const [completed, setcompleted] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [shareTrayOpen, setShareTrayOpen] = useState(false);

  const handleSubscribeClick = () => {
    window.location.href = data.channelLink;
  };

  const handleBootClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setShowSecondPopup(false);
  };

  const showSecondPopupHandler = () => {
    setShowSecondPopup(true);
  };

  const backToFirstPopup = () => {
    setShowSecondPopup(false);
    setShowThirdPopup(false);
  };

  const handleProfileClick = () => {
    setShowThirdPopup(true);
  };

  useEffect(() => {
    const fetchChannelData = async () => {
      if(!videoId){
        console.error("No video ID provided");
        setChannelData(DEFAULT_METADATA);
        setloading(false);
        setcompleted(true);
        props.onApiDataLoaded(DEFAULT_METADATA);
        return;
      }
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}ytChannelDetails/?videoId=${videoId}`
        );

        const fetchedData = response.data || {};
        setChannelData({
          bio: fetchedData.channelDescription || DEFAULT_METADATA.bio,
          truncatedBio:
            (fetchedData.channelDescription || DEFAULT_METADATA.bio).slice(
              0,
              65
            ) + "...",
          channelName: fetchedData.channelName || DEFAULT_METADATA.channelName,
          banner: fetchedData.banner || DEFAULT_METADATA.banner,
          avatar: fetchedData.avatar || DEFAULT_METADATA.avatar,
          channelLink: fetchedData.channelLink || DEFAULT_METADATA.channelLink,
          links: fetchedData.links || DEFAULT_METADATA.links,
        });

        setloading(true);
        setTimeout(() => {
          setcompleted(true);
          props.onApiDataLoaded();
        }, 0);
      } catch (error) {
        console.error("Error fetching channel data:", error);
        setChannelData(DEFAULT_METADATA);
        setloading(true);
        setTimeout(() => {
          setcompleted(true);
          props.onApiDataLoaded();
        }, 0);
      }
    };

    fetchChannelData();
  }, [videoId, props.onApiDataLoaded]);

  return (
    <>
      {!completed ? (
        <div className="min-h-screen flex flex-col justify-center items-center bg-black text-white">
          {!loading ? (
            <div className="flex flex-col items-center gap-4">
              <img src={logo} alt="AppOpener Logo" className="w-20 h-20" />
              <span className="text-lg">Please Wait...</span>
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-white border-opacity-50"></div>
            </div>
          ) : (
            <div className="text-4xl text-green-500">&#x2713;</div>
          )}
        </div>
      ) : (
        <header className="flex flex-row justify-between items-center pl-4 pr-2 bg-my-teal">
          <div className="flex flex-col">
            <div className="flex flex-row items-center">
              <img
                src={data.avatar}
                alt="Profile Avatar"
                className="relative flex shrink-0 overflow-hidden rounded-full h-8 w-8 md:h-10 md:w-10 border-2 border-youtuber-accent"
              />
              <div className="text-sm sm:text-lg md:text-xl font-bold text-white font-rubik mx-2 mt-2">
                {data.channelName}
                <div className="flex flex-wrap gap-2">
                  {data.links &&
                    data.links.map((link, index) => (
                      <a
                        key={index}
                        href={`https://${link.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:scale-110 transition-transform duration-200"
                      >
                        <img
                          src={link.favicon[0]?.url}
                          alt={`Favicon for ${link.title}`}
                          className="w-4 h-4"
                        />
                      </a>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center justify-center gap-2 justify-end my-2">
            <button
              onClick={() => {
                setShareTrayOpen(true);
                props.onCancelRedirect();
              }}
              className="relative overflow-hidden rounded-xl transition-all duration-200 flex items-center justify-center button-gradient-red hover:opacity-90 text-white w-full text-md font-medium p-2 border-2 border-white"
            >
              Share
            </button>
            <button
              onClick={() => {
                setDialogOpen(true);
              }}
              className="relative overflow-hidden rounded-xl transition-all duration-200 flex items-center justify-center button-gradient-blue hover:opacity-90 text-white w-full text-md font-medium p-2 bg-[#42b883] hover:bg-[#42b883]/90"
            >
              Meet
            </button>
          </div>
        </header>
      )}

      <ContactDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        Creator1={data.channelName}
        Video = {props.video_id}
        LInk = {props.url}
      />
      <ShareTray open={shareTrayOpen} onOpenChange={setShareTrayOpen} />

      <Boot
        show={showPopup}
        onClose={closePopup}
        onNextPopup={showSecondPopupHandler}
        onBack={backToFirstPopup}
        showSecondPopup={showSecondPopup}
        showThirdPopup={showThirdPopup}
        onProfileClick={handleProfileClick}
      />
    </>
  );
};

export default UserProfile;
